import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NewsGrid from '../components/NewsGrid';
import { fetchNews } from '../api';

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchNews(24).then(d => { setItems(d.items || []); setLoading(false); }).catch(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen bg-cream-100 text-ink-700">
      <Header />
      <section className="bg-ink-800 text-cream-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="kicker text-copper-500 mb-4">News feed</div>
          <h1 className="font-serif text-[56px] md:text-[68px] leading-[0.98] tracking-tight">
            The press <span className="italic font-light text-copper-500">on Ottawa.</span>
          </h1>
          <p className="mt-6 text-[16px] text-cream-100/75 max-w-2xl leading-relaxed">
            Live coverage from twelve Canadian outlets, filtered to government spending, integrity and accountability stories.
          </p>
        </div>
      </section>
      <main>
        <NewsGrid items={items} loading={loading} />
      </main>
      <Footer />
    </div>
  );
}
